import { render, staticRenderFns } from "./PedidoCuentaShow.vue?vue&type=template&id=8128c7aa"
import script from "./PedidoCuentaShow.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports